import React from 'react';

const Mark = ({ className }) => (
  <svg className={className} width="226" height="140" viewBox="0 0 226 140" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>Subscribe Pro</title>
    <path d="M225.672 0H159.975L113.048 46.9269H178.746V92.3606H113.048V139.288H225.672V0Z" fill="#33D9A5" />
    <path d="M113.048 92.3606H47.35H47.3497V46.9269H47.35H113.048V0H0.423096V139.288H66.1207L113.048 92.3606Z" fill="#33D9A5" />
  </svg>
);

export default Mark;
